import { render } from "./server_paginated_table.html?vue&type=template&id=70b593b6&scoped=true&external"
import script from "./server_paginated_table.js?vue&type=script&lang=js&external"
export * from "./server_paginated_table.js?vue&type=script&lang=js&external"

import "./ServerPaginatedTable.vue?vue&type=style&index=0&id=70b593b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b593b6"]])

export default __exports__